/* PS AFEX S8 Lead Capture — pre-fill name + recipe unlock on success */
(function () {
  if (window.__PS_AFEX_S8__) return;
  window.__PS_AFEX_S8__ = true;

  function prefillName() {
    var section = document.querySelector('.ps-afex-s8-leadcap');
    if (!section) return;
    var nameEl = section.querySelector('.leadcap-name');
    if (!nameEl) return;
    if (nameEl.value && nameEl.value.trim() !== '') return;

    var userName = window.PS_AFEX && window.PS_AFEX.userName;
    var valid = window.PS_AFEX && window.PS_AFEX.hasValidName
      ? window.PS_AFEX.hasValidName(userName)
      : !!(userName && userName !== 'Guest');
    if (!valid) return;
    nameEl.value = userName;
  }

  function revealFallback() {
    var section = document.querySelector('.ps-afex-s8-leadcap');
    if (!section) return;
    var els = section.querySelectorAll('.reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function unlockRecipeCard(section) {
    var card = section.querySelector('.leadcap-recipe-card');
    if (!card || card.classList.contains('is-unlocked')) return;
    card.classList.add('is-unlocked');
    card.setAttribute('data-locked', 'false');
    if (window.PS_AFEX && typeof window.PS_AFEX.playTick === 'function') {
      try { window.PS_AFEX.playTick(880, 0.045, 'triangle'); } catch (e) {}
    }
  }

  function observeRecipeUnlock() {
    var section = document.querySelector('.ps-afex-s8-leadcap');
    if (!section) return;
    var success = section.querySelector('.leadcap-success');
    var card = section.querySelector('.leadcap-recipe-card');
    if (!success || !card) return;

    function maybeUnlock() {
      if (!success.hasAttribute('hidden')) unlockRecipeCard(section);
    }

    maybeUnlock();

    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { maybeUnlock(); });
    mo.observe(success, { attributes: true, attributeFilter: ['hidden'] });
  }

  function init() {
    prefillName();
    revealFallback();
    observeRecipeUnlock();
    document.addEventListener('ps-afex:username', prefillName);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
